import React from 'react';
import { Bar, Chart } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Utils from '../../../providers/Utils';
import SpecificComponent from '../../../commons/SpecificComponent';


export default class PreviziuniChartData extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
        Chart.plugins.unregister(ChartDataLabels);
    }

    colorSwitch = (label) => {

        switch (label) {
            case this.dictionary.financiarContabil.stationara:
                return '#6262d6';
            case this.dictionary.financiarContabil.negativa:
                return '#ea1515';
            case this.dictionary.financiarContabil.pozitiva:
                return '#1ab91a';
            default:
                return 'gray'
        }


    }
    render() {
        return (
            <div style={{
                width: '45%', display: 'inline-block',
                position: 'relative',
                marginRight: 20,
                marginTop: 30,
                verticalAlign: 'top',
                border: '1px dashed gray'
            }} >

                <div style={{
                    position: 'absolute', right: 5, zIndex: 5000, top: 5,
                }}>

                    <div

                        style={{
                            display: 'inline-block',
                            verticalAlign: 'middle',

                            cursor: 'help',
                            width: 85,
                            height: 85,
                            backgroundColor: this.colorSwitch(this.props.c.tipAnticipare),
                            borderRadius: '50%'
                        }}>
                        <span className='pm-title' style={{ lineHeight: '80px', color: 'white', fontSize: 16 }}>{this.props.c.tipAnticipare}</span>
                    </div>
                </div>
                <h3 style={{ marginBottom: 0 }} className='pm-title'>{this.props.c.titlu}</h3>
                <Bar

                    datasetKeyProvider={() => { return Math.random() }}
                    // getElementAtEvent={(element)=>this.getLineData(element,i)}
                    plugins={[ChartDataLabels]}

                    data={{
                        labels: this.props.c.labels.map((r) => { return (r) }),
                        datasets: [
                            {
                                //    label:ch.chartData.map((r)=>{return(Number(r))}) ,
                                backgroundColor: this.props.c.tipAnticipare !== 'Pozitiva' ? ['rgb(26, 185, 26)', 'darkorange', 'red'] : ['red', 'darkorange', 'rgb(26, 185, 26)'],
                                hoverBackgroundColor: this.props.c.chartPrognoza.map((r) => { return (new Utils().culoriCharts(Number(r.toFixed(0)))) }),
                                data: this.props.c.chartPrognoza.map((r) => { return (Number(r.toFixed(2))) }),

                            }
                        ],


                    }}

                    options={{

                        onClick: function (evt, elements) {

                            let selectedIndex = null
                            if (elements && elements.length) {
                                var segment = elements[0];
                                this.update();
                                if (selectedIndex !== segment["_index"]) {
                                    selectedIndex = segment["_index"];
                                    segment._model.outerRadius += 20;
                                }
                                else {
                                    selectedIndex = null;
                                }
                            }
                        },
                        layout: {
                            padding: 60,
                            height: 300
                        },

                        plugins: {

                            datalabels: {
                                color: 'black',
                                formatter: (value, context) => {
                                    // console.log('value :', value);
                                    //    console.log('context :', );

                                    return value

                                },
                                font: {
                                    size: 16,
                                    weight: 600
                                },
                                align: 'end',
                                display: 'auto',
                                clamp: true


                            },

                        },
                        legend: {
                            display: false
                        }
                    }}

                />


             

            </div>

               




         
        );
    }
}